import { commonMessages } from './commonMessages'
import { pageMessages } from './pageMessages'
import { kratosMessages } from './kratosMessages'
import { backgroundMessages } from './backgroundMessages'

export type Locale = 'en' | 'zh-CN'
export type TranslationParams = Record<string, string | number>
export type Translator = (source: string, params?: TranslationParams) => string
export const LOCALE_STORAGE_KEY = 'toga-auth-locale'

const chineseMessages: Record<string, string> = { ...commonMessages, ...pageMessages, ...kratosMessages, ...backgroundMessages }

export function translate(locale: Locale, source: string, params?: TranslationParams): string {
  const message = locale === 'zh-CN' && Object.prototype.hasOwnProperty.call(chineseMessages, source) ? chineseMessages[source] : source
  // Callback replacement keeps user/provider values literal, including "$&".
  return message.replace(/\{(\w+)\}/g, (placeholder, name: string) =>
    params && Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : placeholder)
}

export function normalizeLocale(value: string | null | undefined): Locale | undefined {
  const language = value?.toLowerCase().split(/[-_]/)[0]
  if (language === 'zh') return 'zh-CN'
  if (language === 'en') return 'en'
  return undefined
}

export function detectLocale(): Locale {
  try {
    const saved = normalizeLocale(window.localStorage.getItem(LOCALE_STORAGE_KEY))
    if (saved) return saved
  } catch { /* Storage can be blocked; browser preferences still work. */ }
  if (typeof navigator !== 'undefined') {
    for (const language of [...(navigator.languages || []), navigator.language]) {
      const locale = normalizeLocale(language)
      if (locale) return locale
    }
  }
  return 'en'
}
